import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CoreService } from '../../../../services/core.service';
import { StepperGridComponent } from '../../components/stepper-grid/stepper-grid.component';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';
import { SubmitGridComponent } from '../../components/submit-grid/submit-grid.component';
import { FooterGridComponent } from '../../components/footer-grid/footer-grid.component';

@Component({
  selector: 'app-create-company',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, SectionGridComponent, SubmitGridComponent, StepperGridComponent, FooterGridComponent],
  templateUrl: './create-company.component.html',
  styleUrl: './create-company.component.scss'
})

export class CreateCompanyComponent {
  companyForm: FormGroup;

  @Output() onSubmitClbk = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private coreService: CoreService,
    private router: Router
  ) {
    this.companyForm = this.fb.group({
      Name: ['', Validators.required],
      city: [''],
      address: ['']
    });
  }

  ngOnInit() {

  }

  onSubmit(): void {
    if (this.companyForm.valid) {

      const formData = this.companyForm.value;

      this.coreService.postData('manageAccount/company/store', formData).subscribe({
        next: (data) => {

          const companyId = data.ID || data.id || data.data?.ID || data.data?.id;

          if (companyId) {
            this.router.navigate(['/manage-account/create-user', companyId]);
          } else {
            console.error('No company ID found in response:', data);
          }
          
          // Optional: Reset form
          // this.resetForm();
          
        },
        error: (error) => {
          console.error('Error creating company:', error);
        }

      });
    } else {
      this.markFormGroupTouched(this.companyForm);
    }
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  resetForm() {
    this.companyForm.reset({
      Name: '',
      city: '',
      address: ''
    });
  }

  get nameControl() {
    return this.companyForm.get('Name');
  }

  get cityControl() {
    return this.companyForm.get('city');
  }

  get addressControl() {
    return this.companyForm.get('address');
  }
}
